"use client";

import { ReactNode } from "react";
import { ShepherdJourneyProvider } from "react-shepherd";
import WalkthroughDebugPanel from "./WalkthroughDebugPanel";

export default function WalkthroughProvider({ children }: { children: ReactNode }) {
	return (
		<ShepherdJourneyProvider>
			<WalkthroughDebugPanel />
			{children}
		</ShepherdJourneyProvider>
	);
}
